<template>
  <div class="mainBody">
    <div class="titcn">{{ cn }}</div>
    <div class="titen">
      <div class="unLine"><i class="point"></i><span class="line"></span></div>
      <div class="titen_txt">{{ en }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["cn", "en"],
};
</script>
<style lang="scss" scoped>
.unLine {
  width: auto;
  height: 4px;
  box-sizing: border-box;
  display: inline-block;
  margin-top: 30px;
  .point {
    display: inline-block;
    width: 6px;
    height: 4px;
    border-radius: 5px;
    background: #87c31e;
    vertical-align: middle;
  }
  .line {
    width: 66px;
    height: 4px;
    border-radius: 5px;
    background: #87c31e;
    margin-left: 4px;
    display: inline-block;
    vertical-align: middle;
  }
}
.titcn {
  font-size: 24px;
  color: #333333;
}
.titen_txt {
  display: inline-block;
  color: #666666;
  font-size: 18px;
  margin-left: 10px;
}
</style>